module.exports = __webpack_public_path__ + "mainassets/img/back-to-top.7cc01ba7.svg";